import { Box, Skeleton, Text, UnstyledButton } from "@mantine/core";
import type { CSSProperties } from "react";
import classes from "./KpiRow.module.css";

export interface KpiItem {
  key: string;
  label: string;
  value: string;
  sub?: string;
  loading?: boolean;
  /** Makes the card a button (old KpiGrid cards opened their module). */
  onClick?: () => void;
}

export interface KpiRowProps {
  items: KpiItem[];
}

/** Canvas 2.2–2.5: KPI картын мөр; баганын тоо = items.length (--kpi-cols). */
export function KpiRow({ items }: KpiRowProps) {
  if (items.length === 0) return null;
  const vars = { "--kpi-cols": items.length } as CSSProperties;

  return (
    <Box component="section" className={classes.grid} style={vars}>
      {items.map((k) =>
        k.loading ? (
          <Skeleton key={k.key} h={112} radius={14} />
        ) : (
          k.onClick ? (
            <UnstyledButton key={k.key} className={classes.card} data-clickable onClick={k.onClick}>
              <KpiBody item={k} />
            </UnstyledButton>
          ) : (
            <Box key={k.key} className={classes.card}>
              <KpiBody item={k} />
            </Box>
          )
        ),
      )}
    </Box>
  );
}

function KpiBody({ item }: { item: KpiItem }) {
  return (
    <>
      {/* span: a <p> is not allowed inside the <button> variant; the card is a flex column. */}
      <Text span className={classes.muted}>{item.label}</Text>
      <Text span className={classes.value}>{item.value}</Text>
      {item.sub && <Text span className={classes.muted}>{item.sub}</Text>}
    </>
  );
}
